import SkillItem from '../../../../../../components/Cards/CardComponents/SkillItem'
import { Skill } from '../../../../../../types/skill'

interface SkillSectionProps {
  skills: Skill[]
}

export function SkillSection({ skills }: SkillSectionProps) {
  if (!skills?.length) return null

  return (
    <div className="tc-mv-question-field p-4 rounded-2xl text-white space-y-2">
      <h2 className="text-xl font-semibold">Skills</h2>
      <div className="space-y-8">
        {skills.map((skill, index) => (
          <SkillItem key={index} skill={skill} />
        ))}
      </div>
    </div>
  )
}
